<template>
	<div>
		<top :id="'mine'"></top>
		<div class="con">
			<breadcrumb :url="url"></breadcrumb>
			<div class="flex">
				<div class="left">
					<div class="user flex ali-cen jus-cen">
						<img :src="userInfo.avatar" alt="">
						<div>
							<div style="color: 20rpx;color: #0097FE;">{{userInfo.nickname}}</div>
							<div style="color: #666;font-size: 16px;">{{userInfo.mobile}}</div>
						</div>
					</div>
					<div class="menu">
						<div class="menu-item" v-for="(item,index) in menu" :key="index">
							<div class="menu-title" :class="{'blue' : menuTitleId == item.id}" :style="index == 0 ? 'border-top:none' : ''" @click="clickMenu(item.id)">
								<i :class="item.icon+'iconfont'"></i>
								<span>{{item.name}}</span>
								<i class="ficon-down iconfont"></i>
							</div>
							<div class="menu-child" v-if="item.id == menuTitleId">
								<div class="menu-text"  @click="click(items.id,item.id)" v-for="(items,i) in item.child"  :key="i">
									<span  :class="{'menu-text-true' : menuId == items.id}">{{items.name}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="right" :class="menuId == 13 ||12?'border':'right'">
					<order v-if="menuId == 11" @checkView="checkView"></order>
					<!-- <orderDetail v-if="menuId == 16" :value="value" @checkView="checkView" ></orderDetail>
					<refund v-if="menuId == 17" :value="value" @checkView="checkView" ></refund> -->
                    <!-- 草稿箱 -->
                    <deafts v-if="menuId == 43" @checkView="checkView"></deafts>
                    <!-- 商品收藏 -->
                    <shoppingCollect v-if="menuId == 21" @checkView="checkView"></shoppingCollect>
                    <!-- 收件箱 -->
                    <inbox v-if="menuId == 42" @checkView="checkView"></inbox>
                    <!-- 给管理员发送信息 -->
                    <sendAdministrator v-if="menuId == 45" @checkView="checkView"></sendAdministrator>
                    <!-- 我的红包 -->
                    <redPacked v-if="menuId == 13"  @checkView="checkView"></redPacked>
                    <!-- 采购清单 -->
                    <purchasing v-if="menuId == 22" @checkView="checkView"></purchasing>
                    <!-- 个人信息 -->
                    <pim v-if="menuId == 31" @checkView="checkView"></pim>
                    <!-- 修改密码 -->
                    <changePassword v-if="menuId == 32" @checkView="checkView"></changePassword>
                    <!-- 收货地址 -->
                    <haevesAddress v-if="menuId == 33" @checkView="checkView"></haevesAddress>
                    <!-- 我的优惠卷 -->
                    <preferentialCard v-if="menuId == 15" @checkView="checkView"></preferentialCard>
                    <!-- 积分兑换优惠卷 -->
                    <priceExchange v-if="menuId == 16"  @checkView="checkView"></priceExchange>
                    <!-- 积分兑换商品 -->
                    <pointForGoods v-if="menuId == 17"  @checkView="checkView"></pointForGoods>
                    <!-- 评价 -->
                    <!-- <evaluate v-if="menuId == 18" :value="value"  @checkView="checkView"></evaluate> -->
                    <!-- 我的积分 -->
                    <integral v-if="menuId == 12" :value="value"  @checkView="checkView"></integral>
                    <!-- 发件箱 -->
                    <outBox v-if="menuId == 44" :value="value"  @checkView="checkView"></outBox>
                    <!-- 发送信息 -->
                    <sendInformation v-if="menuId == 41" :value="value"  @checkView="checkView"></sendInformation>
                    <!-- 历史采购清单 -->
                    <pruchasList v-if="menuId == 23" :value="value"  @checkView="checkView"></pruchasList>
                    <!-- 我的会员 -->
                    <myVip v-if="menuId == 14" :value="value"  @checkView="checkView"></myVip>


				</div>
			</div>
		</div>
		<bottom></bottom>
	</div>


</template>
<script>
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
import {shoproUser} from '@/api/index.js';
	import top from '../../../components/top.vue'
	import bottom from '../../../components/bottom.vue'
	import breadcrumb from '../../../components/breadcrumb.vue'
	import {menu} from './menu.js'
	import order from './components/order.vue'
	// import orderDetail from './components/orderDetail.vue'
    // import refund from './components/refund.vue'
    // 草稿箱
    import deafts from './components/drafts.vue'
    // 商品收藏
    import shoppingCollect from './components/shoppingCollect.vue'
    // 收件箱
    import inbox from './components/Inbox'
    // 给管理员发送信息
    import sendAdministrator from './components/sendAdministrator'
    // 我的红包
    import redPacked from './components/redPacked'
    // 采购清单
    import purchasing from './components/purchasingList'
    // 个人信息
    import pim from './components/pim'
    // 修改密码
    import changePassword from './components/chnagePassword'
    // 收货地址
    import haevesAddress from './components/harvestAddress'
    //我的优惠卷
    import preferentialCard from './components/preferentialCard'
    // 积分兑换优惠卷
    import priceExchange from './components/prieceExchange'
    // 评价
    // import evaluate from './components/evaluate'
    //我的积分
    import integral from './components/integral'
    //发件箱
    import outBox from './components/outBox'
    //发送信息
    import sendInformation from './components/sendInformation'
    //采购列表
    import pruchasList from './components/pruchasList'
    // 我的会员
    import myVip from './components/myVip'
    // 积分兑换商品
    import pointForGoods from './components/pointsForGoods'
	export default{
		components:{
			top,
			bottom,
			breadcrumb,
			order,
			// orderDetail,
            // refund,
            deafts,
            shoppingCollect,
            inbox,
            sendAdministrator,
            redPacked,
            purchasing,
            pim,
            changePassword,
            haevesAddress,
            preferentialCard,
            priceExchange,
            // evaluate,
            integral,
            outBox,
            sendInformation,
            pruchasList,
            myVip,
            pointForGoods
		},
		data(){
			return{
				url:[{name:'会员中心',url:'/mine'}],
				userInfo:{},
				menu:[],
				menuId:'11',
				orderDetailId:'0',  //订单id
				menuTitleId:'1',
				value:{},  //传入数据a
			}
		},
		beforeCreate () {
            document.querySelector('body').setAttribute('style', 'background:#f5f5f5')

		},
		created() {
            this.menu = menu
            this.getShoperUser()
		},
		methods:{
			click(e,id){
				this.menuId = e
				this.menuTitleId = id
			},
			clickMenu(e){
				if(e == this.menuTitleId){
					this.menuTitleId = -1
				}else{
					this.menuTitleId = e
				}
			},
			checkView(e){

				this.menuId = e.menuId
				this.value = e.data
				console.log(e,'eee')
            },
            //获取用户信息
            getShoperUser(){

             shoproUser({},header).then(res=>{
        //   window.localStorage.setItem('userInfo',JSON.stringify(res.data));
            console.log(res.data);
            if(res.code !== 1){
                return
            }
            this.userInfo = res.data
          })
            },
		}
    }

</script>

<style lang="less" scoped>
   .border{
       border: none !important;
   }
	.con{
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 30px;
	}
	.left{
		margin-right: 10px;
		.user{
			width: 210px;
			height: 94px;
			background: #FFFFFF;
			border-radius: 8px;
			border: 1px solid #0097FE;
			margin-bottom: 20px;
			img{
				width: 50px;
				height: 50px;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.menu{
			width: 211px;
			background: #FFFFFF;
			border-radius: 8px;
			border: 1px solid #0097FE;
			.menu-item{
				.menu-title{
					font-size: 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					height: 50px;
					border-bottom: solid 1px #D5D5D5;
					border-top:solid 1px #D5D5D5;
					span{
						margin: 0 10px;
					}
				}

				.menu-child{
					text-align: center;
					color: #999;
					font-size: 16px;
					.menu-text{
						height: 40px;
						line-height: 40px;
					}
					.menu-text-true{
						color: #0097FE;
						border-bottom: 2px solid;
					}
				}
			}
		}
	}
	.right{
		width: 100%;
		border: 1px solid #0097FE;
		border-radius: 8px;
		// padding: 30px;
		background-color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/mine.vue